import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import memoize from 'memoize-one';
import { useAbility } from '@casl/react';
import { ComponentDataTable, DefaultModal } from '../../../components';
import { legalAttendanceReport } from '../../../requests/legalreports';
import { indexEmployeesRequest } from '../../../requests/employees';
import { AbilityContext } from '../../../config/abilityContext';
import { AttendanceFilterDataTable } from '../../../components/LegalReport';
import { downloadFile } from '../../../services/utils';
import LegalReportFilter from '../../Legalreports/Filters/LegalReportFilter';
import ReportActions from '../../Legalreports/ReportActions';

const columns = memoize(() => [
  {
    name: 'RUT',
    selector: 'national_identification',
    sortable: true,
    grow: '1'
  },
  {
    name: 'NOMBRE',
    selector: 'name',
    cell: item => <>{item.full_name}</>,
    sortable: true,
    grow: '2'
  },
  {
    name: 'LUGAR DE PRESTACION DE SERVICIOS',
    selector: 'branch_office',
    sortable: false,
    grow: '3'
  }
]);

const recordsColumns = memoize(() => [
  {
    name: 'FECHA',
    selector: 'date',
    sortable: true,
    grow: '1'
  },
  {
    name: 'HORARIO/EVENTO',
    selector: 'shift_name',
    sortable: true,
    grow: '3'
  },
  {
    name: 'POSEE ASISTENCIA',
    selector: 'attendance',
    sortable: true,
    grow: '1'
  },
  {
    name: 'PERMISO/JUSTIFICACIÓN',
    selector: 'justification',
    sortable: true,
    grow: '4'
  }
]);

export const MyExpander = props => {
  const { data, dateRange } = props;
  const { id } = data;
  return (
    <AttendanceFilterDataTable
      columns={recordsColumns}
      customParams={{ filter_by_employee: id, date_range: dateRange }}
      props
    />
  );
};

export const LoadingTranslation = () => {
  return <h3>Cargando...</h3>;
};

const AttendanceReportDataTable = () => {
  const [onRequest, setOnRequest] = useState(false);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [wordModalShow, setWordModalShow] = useState(false);
  const [query, setQuery] = useState({});
  const [filters, setFilters] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [haveDateRange, setHaveDateRange] = useState(false);
  const [searchFirstStart, setSearchFirstStart] = useState(false);
  const [amount, setAmount] = useState(0);
  const { currentEmployee } = useSelector(state => state.auth);
  const ability = useAbility(AbilityContext);
  const dispatch = useDispatch();

  const handleRequest = async (params, format, responseType = 'json') => {
    setOnRequest(true);
    const empParams = { ...params };
    delete empParams.date_to;
    delete empParams.date_from;
    delete empParams.range_date;
    setQuery(empParams);
    indexEmployeesRequest({
      dispatch,
      params: { ...filters, ...empParams, active: true, is_dt: false, filter_ids: currentEmployee },
      format,
      responseType,
      successCallback: response => {
        const { data } = response;
        setAmount(data.metadata.amount);
        setFilteredEmployees(data.data);
      },
      callback: () => setOnRequest(false)
    });
  };

  const handleAttendanceReportRequest = async (params, format, type = 'json') => {
    const responseType = format === '.docx' ? 'blob' : type;
    setOnRequest(true);
    legalAttendanceReport({
      dispatch,
      params: { filter_by_employee: currentEmployee, date_range: dateRange, ...params, paginate: false },
      format,
      responseType,
      successCallback: response => {
        if (format === '.xlsx' || format === '.docx') {
          downloadFile(response);
        }
      },
      callback: () => setOnRequest(false)
    });
  };

  const handleFilters = params => {
    const empParams = { ...params };
    delete empParams.date_to;
    delete empParams.date_from;
    delete empParams.range_date;
    setFilters(empParams);
    setSearchFirstStart(true);
    setDateRange(params.range_date);
    setHaveDateRange(true);
    handleRequest(params);
  };

  const handleMassAction = action => {
    switch (action) {
      case 'download_excel':
        setModalShow(true);
        break;
      case 'download_docx':
        setWordModalShow(true);
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
    }
  };
  return (
    <>
      <LegalReportFilter formRequest={handleFilters} filterRRHH={false} />

      <ComponentDataTable
        onRequest={onRequest}
        columns={columns()}
        data={filteredEmployees}
        totalRows={amount}
        withMassActions={ability.can('index', 'AttendanceReport')}
        massActions={<ReportActions disabled={!haveDateRange || onRequest} handleClick={handleMassAction} />}
        resourceRequest={handleRequest}
        expandableRows
        progressPending={onRequest}
        progressComponent={<LoadingTranslation />}
        pagination={false}
        expandableRowsComponent={<MyExpander dateRange={dateRange} />}
        searchFirstStart={searchFirstStart}
      />
      <DefaultModal
        title="Exportar Reporte de Asistencias"
        body="¿Estás seguro que quieres exportar el reporte de asistencia en formato Excel?"
        show={modalShow}
        handleClose={() => setModalShow(false)}
        handleConfirm={() => {
          handleAttendanceReportRequest(query, '.xlsx', 'text');
          setModalShow(false);
        }}
        titleBtnClose="Cancelar"
        titleBtnSave="Confirmar"
      />
      <DefaultModal
        title="Exportar Reporte de Asistencias"
        body="¿Estás seguro que quieres exportar el reporte de asistencia en formato Word?"
        show={wordModalShow}
        handleClose={() => setWordModalShow(false)}
        handleConfirm={() => {
          handleAttendanceReportRequest(query, '.docx', 'text');
          setWordModalShow(false);
        }}
        titleBtnClose="Cancelar"
        titleBtnSave="Confirmar"
      />
    </>
  );
};

export default AttendanceReportDataTable;
